import { FC } from 'react';
import { TenantLayout, AuthorizedPage } from '@maxtropy/components';

import styles from './index.module.scss';

type LayoutProps = {
  children?: React.ReactNode;
};

const Layout: FC<LayoutProps> = ({ children }) => {
  // useEffect(() => {
  //   activateTheme(Themes.DARK);
  // }, []);

  // 微前端模式由主壳 AuthBootstrap 和 TenantLayout 统一负责认证与外层布局，
  // 此处只保留选择员工页面自己的容器，避免重复 probe/current/permission 和 landing 竞争。
  if (window.__MICRO_APP_ENVIRONMENT__) {
    return <div className={styles.layout}>{children}</div>;
  }

  return (
    <div className={styles.layout}>
      <AuthorizedPage>
        <TenantLayout isDefaultLogo>{children}</TenantLayout>
      </AuthorizedPage>
    </div>
  );
};

export default Layout;
